import { useUserStore } from '@/store';
import { type ReactNode } from 'react';
import { PermissionContext } from './PermissionContext';

export const PermissionProvider = ({ children }: { children: ReactNode }) => {
  const { user } = useUserStore();
  const permissions = user?.permissions || new Map();

  const path = window.location.pathname;

  let hasPermission: (key: string) => boolean;
  if (!permissions) {
    hasPermission = () => false;
  } else {
    if (permissions.has(path)) {
      if (permissions.get(path)?.length) {
        hasPermission = (key: string) => permissions.get(path)!.includes(key);
      } else {
        hasPermission = () => true;
      }
    } else {
      hasPermission = () => false;
    }
  }

  return (
    <PermissionContext.Provider value={{ hasPermission }}>
      {children}
    </PermissionContext.Provider>
  );
};

export default PermissionProvider;
